module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/feature-lot-3be61b4a27fa1d4e26070bbd65598292.png";